<template>
    <div>
        <div
            v-show="!mostrarSubItens && !inserirAtualizarItem && !detalharItem"
        >
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-alert
                show
                variant="warning"
                v-if="mostrarBtnAtualizarItemContrato && !temDadosRM()"
            >
                <span>
                    <strong>
                        Para ter acesso a atualização dos itens, complete a
                        secção "Dados RM"
                    </strong>
                </span>
            </b-alert>
            <app-tabela
                idTabela="tblItensContrato"
                :itens="contrato.itensContrato"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="botoes">
                    <div class="d-flex flex-row-reverse mb-3">
                        <b-form-group>
                            <!-- <btn-inserir-item-contrato
                                :contrato="contrato"
                                :apostilamento="apostilamento()"
                                @obterItensAtualizados="
                                    $emit('obterContratoAtualizado')
                                "
                                v-if="mostrarBtnInserirItemContrato"
                            ></btn-inserir-item-contrato> -->
                            <b-button
                                variant="primary"
                                @click.stop="mostrarInserirItem()"
                                v-if="mostrarBtnInserirItemContrato"
                            >
                                <span>
                                    <i class="fa fa-plus mr-2"></i> Inserir Item
                                </span>
                            </b-button>
                            <btn-atualizar-valores-em-lote-item-contrato
                                :itensSelecionados="itensSelecionados"
                                :apostilamento="apostilamento()"
                                :contrato="contrato"
                                v-if="
                                    mostrarBtnAtualizarValoresEmLoteItemContrato
                                "
                                @obterItensAtualizados="
                                    $emit('obterContratoAtualizado')
                                "
                                @limparItensSelecionados="
                                    itensSelecionados = []
                                "
                            ></btn-atualizar-valores-em-lote-item-contrato>
                        </b-form-group>
                    </div>
                </template>
                <template slot="acoes" slot-scope="data">
                    <span class="text-primary float-left mr-1">
                        <i
                            class="fa fa-list fa-lg icon-button"
                            title="Detalhar Item"
                            @click.stop="mostrarItem(data)"
                        ></i>
                    </span>
                    <span class="text-primary float-left mr-1">
                        <i
                            class="fa fa-info-circle fa-lg icon-button"
                            title="Detalhar Sub-Itens"
                            @click.stop="detalharSubItens(data.itemContratoId)"
                        ></i>
                    </span>
                    <span class="text-primary float-left mr-1">
                        <i
                            class="fa fa-edit fa-lg icon-button"
                            title="Atualizar Item"
                            @click.stop="mostrarAtualizarItem(data)"
                            v-if="
                                mostrarBtnAtualizarItemContrato && temDadosRM()
                            "
                        ></i>
                    </span>
                    <btn-ativar-desativar-item-contrato
                        :item="data"
                        :apostilamento="apostilamento()"
                        :contrato="contrato"
                        v-if="mostrarBtnAtivarDesativarItemContrato"
                        @obterItensAtualizados="
                            $emit('obterContratoAtualizado')
                        "
                        @atualizarMensagemErro="erros = $event"
                    ></btn-ativar-desativar-item-contrato>
                </template>
                <template slot="valorUnitario" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.valorUnitario | currency }}
                    </p>
                </template>
                <template slot="saldoValor" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.saldoValor | currency }}
                    </p>
                </template>
                <template slot="saldoValorReal" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.saldoValorReal | currency }}
                    </p>
                </template>
                <template slot="status" slot-scope="data">
                    <app-status
                        :status="data.status == 1 ? 'ATIVO' : 'INATIVO'"
                    ></app-status>
                </template>
                <template slot="HEAD_itemSelecao">
                    <i
                        class="fa fa-check-square fa-lg text-muted icon-button p-0 m-0"
                        title="Marcar/Desmarcar todos"
                        @click.stop="marcarDesmarcarTodas()"
                    ></i>
                </template>
                <template slot="itemSelecao" slot-scope="data">
                    <b-form-checkbox
                        :value="data.itemContratoId"
                        v-model="itensSelecionados"
                        v-if="data.status === 1"
                    ></b-form-checkbox>
                </template>
            </app-tabela>
        </div>
        <div v-if="mostrarSubItens">
            <app-sub-itens-contrato
                :itemContrato="itemContrato"
                :contrato="contrato"
                @fecharSubItens="itemContrato = null"
                @obterApostilamentoAtualizado="$emit('obterContratoAtualizado')"
            ></app-sub-itens-contrato>
        </div>
        <div v-if="inserirAtualizarItem">
            <btn-inserir-atualizar-item-contrato
                :contrato="contrato"
                :item="item"
                :apostilamento="apostilamento()"
                :acao="acao"
                @fecharInserirAtualizarItem="inserirAtualizarItem = false"
                @obterItensAtualizados="$emit('obterContratoAtualizado')"
            ></btn-inserir-atualizar-item-contrato>
        </div>
        <div v-if="detalharItem">
            <btn-detalhar-item-contrato
                :item="item"
                :contrato="contrato"
                @fecharDetalharItem="detalharItem = false"
            ></btn-detalhar-item-contrato>
        </div>
    </div>
</template>

<script>
import SubItensContrato from './SubItensContrato'
import BtnAtualizarItemContrato from './BtnAtualizarItemContrato'
import BtnAtivarDesativarItemContrato from './BtnAtivarDesativarItemContrato'
import BtnAtualizarValoresEmLoteItemContrato from './BtnAtualizarValoresEmLoteItemContrato'
import { situacaoContrato } from '../SituacaoContrato'
import BtnInserirAtualizarItemContrato from './BtnInserirAtualizarItemContrato'
import BtnDetalharItemContrato from './BtnDetalharItemContrato.vue'

export default {
    components: {
        AppSubItensContrato: SubItensContrato,
        BtnAtualizarItemContrato,
        BtnInserirAtualizarItemContrato,
        BtnAtivarDesativarItemContrato,
        BtnAtualizarValoresEmLoteItemContrato,
        BtnDetalharItemContrato
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            itemContrato: null,
            itensSelecionados: [],
            erros: [],
            campos: [
                {
                    key: 'itemSelecao',
                    label: '',
                    customHead: true
                },
                {
                    key: 'acoes',
                    label: 'Ações',
                    tdClass: 'text-center'
                },
                {
                    key: 'ordem',
                    label: 'Nº',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descricaoResumida',
                    label: 'Descrição Resumida',
                    filterable: true,
                    sortable: true
                },
                // {
                //     key: 'descTipoFaturamento',
                //     label: 'Tipo Faturamento',
                //     filterable: true,
                //     sortable: true
                // },
                // {
                //     key: 'descNatureza',
                //     label: 'Natureza',
                //     filterable: true,
                //     sortable: true
                // },
                {
                    key: 'valorUnitario',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'quantidade',
                    label: 'Qtd',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'saldoValor',
                    label: 'Saldo Previsto',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'saldoValorReal',
                    label: 'Saldo Real',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'qtdSubItens',
                    label: 'Qtd SubItens',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'seqRM',
                    label: 'Seq RM',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    tdClass: 'text-center'
                }
            ],
            itensPorPagina: 5,
            inserirAtualizarItem: false,
            detalharItem: false,
            acao: '',
            item: {}
        }
    },
    methods: {
        detalharSubItens(itemContratoId) {
            this.itemContrato = this.contrato.itensContrato.filter((item) => {
                return item.itemContratoId === itemContratoId
            })[0]
        },

        mostrarInserirItem() {
            this.acao = 'Inserir'
            this.item = null
            this.inserirAtualizarItem = true
        },

        mostrarAtualizarItem(item) {
            this.acao = 'Atualizar'
            this.item = item
            this.inserirAtualizarItem = true
        },

        mostrarItem(item) {
            this.item = item
            this.detalharItem = true
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        apostilamento() {
            return (
                this.$temAcessoView('CONT-APOST-05') &&
                this.situacoesVigenteDistribuido()
            )
        },

        contratoElaboracao() {
            return (
                this.$temAcessoView('CONT-ELAB-01') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        verificaTipoAditivoPrazo() {
            return this.contrato.aditivoContrato != null
                ? this.contrato.aditivoContrato.aditivoTiposAditivo.every(
                      (x) => x.idTipoAditivo == 2
                  )
                : false
        },

        aditivoContratoIniciado() {
            return (
                this.$temAcessoView('CONT-ADITIV-00') &&
                (this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO ||
                    this.contrato.idSituacaoContrato ==
                        situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO) &&
                !this.verificaTipoAditivoPrazo()
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido() &&
                this.contrato.contratoVigente
            )
        },

        // mostrarBtnAtualizarItemContrato(data) {
        //     if (
        //         (this.apostilamento() || this.atualizacaoContrato()) &&
        //         data.status === 1 &&
        //         this.controleHistoricoAditivos()
        //     ) {
        //         return true
        //     } else if (
        //         (this.contratoElaboracao() || this.aditivoContratoIniciado()) &&
        //         data.status === 1
        //     ) {
        //         return true
        //     }
        // },

        marcarDesmarcarTodas() {
            if (this.itensSelecionados.length > 0) {
                this.itensSelecionados = []
            } else {
                this.itensSelecionados = this.contrato.itensContrato
                    .filter((item) => {
                        return item.status === 1
                    })
                    .map((item) => {
                        return item.itemContratoId
                    })
            }
        },

        controleHistoricoAditivos() {
            return (
                this.contrato.contratoVigente ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        contratoIntegrado() {
            return (
                this.contrato.idSituacaoContrato ==
                situacaoContrato.CONTRATO_DISTRIBUIDO
            )
        },

        temDadosRM() {
            return this.contrato.dadosContratoRM != null
        }
    },

    created() {},

    computed: {
        mostrarSubItens() {
            return this.itemContrato !== null
        },

        mostrarBtnInserirItemContrato() {
            return (
                (this.apostilamento() ||
                    // this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnAtualizarItemContrato() {
            return (
                (this.apostilamento() ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos() &&
                !this.contratoIntegrado()
            )
        },

        mostrarBtnAtivarDesativarItemContrato() {
            return (
                (this.apostilamento() ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnAtualizarValoresEmLoteItemContrato() {
            return (
                (this.apostilamento() ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        }
    },

    watch: {
        contrato() {
            if (
                !this.apostilamento() &&
                !this.contratoElaboracao() &&
                !this.aditivoContratoIniciado() &&
                !this.atualizacaoContrato() &&
                !this.controleHistoricoAditivos()
            ) {
                this.campos.shift()
            }
        },

        InserirItem(a) {}
    }
}
</script>
